import {Avatar, Button, Drawer} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import AssessmentIcon from '@material-ui/icons/Assessment';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import EmailRoundedIcon from '@material-ui/icons/EmailRounded';
import GroupIcon from '@material-ui/icons/Group';
import RouterRoundedIcon from '@material-ui/icons/RouterRounded';
import React, {useEffect, useState} from 'react';
import Logo from '../../../assets/JustMeasureLogo.png';
import {useAuth0} from '../../../auth/react-auth0-spa';
import {localized} from '../../../state/i18n/i18n';
import {decodeToken} from '../../../utilities/auth-helper';
import {DrawerItem} from './drawer-item';
import './menu-drawer.scss';

const MenuDrawer: React.FC = () => {
  // const setInitialPath = () => {
  //   if (window.location.pathname === '/notification') {
  //     return '/notification';
  //   }
  //   if (window.location.pathname === '/management') {
  //     return '/management';
  //   } else {
  //     return '/devices';
  //   }
  // };
  const setInitialPath = () => {
    return window.location.pathname;
  };

  const {user, logout, isAuthenticated, getTokenSilently} = useAuth0();
  const logOut = () => logout({returnTo: window.location.origin});
  const [item, setItem] = useState(setInitialPath());
  const [isAdmin, setIsAdmin] = useState(false);

  async function hasAccess() {
    let token = await getTokenSilently();
    let jwtToken = decodeToken(token);
    setIsAdmin(jwtToken.permissions.includes('admin'));
  }

  useEffect(() => {
    const checkHasAccess = async () => {
      await hasAccess();
    };
    checkHasAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setDevice = () => {
    setItem('/devices');
  };
  const setNotification = () => {
    setItem('/notification');
  };
  const setManagement = () => {
    setItem('/management');
  };
  const setTeracomDevice = () => {
    setItem('/teracomdevices');
  };
  const setUsers = () => {
    setItem('/users');
  };
  return (
    <div className="menuDrawerWidth">
      <Drawer className="desktop" variant="permanent" anchor="left">
        <div className="topContainer">
          <img width={117} src={Logo} alt="JustMeasureLogo" className="logo" />
        </div>
        <Divider />

        <List className="DisableFireFoxElements">
          <DrawerItem
            linkTo={'/devices'}
            icon={<RouterRoundedIcon className="blueIcon" />}
            text={localized('Data')}
            selected={item === '/devices' ? true : false}
            onMenuItemClicked={setDevice}
            identifier={'/devices'}
          />

          <DrawerItem
            linkTo={'/notification'}
            icon={<EmailRoundedIcon className="blueIcon" />}
            text={localized('Notification')}
            selected={item === '/notification' ? true : false}
            onMenuItemClicked={setNotification}
            identifier={'/notification'}
          />

          <DrawerItem
            linkTo={'/management'}
            icon={<BallotRoundedIcon className="blueIcon" />}
            text={localized('Devices')}
            selected={item === '/management' ? true : false}
            onMenuItemClicked={setManagement}
            identifier={'/management'}
          />

          <DrawerItem
            linkTo={'/teracomdevices'}
            icon={<AssessmentIcon className="blueIcon" />}
            text={localized('TeracomDevices')}
            selected={item === '/teracomdevices' ? true : false}
            onMenuItemClicked={setTeracomDevice}
            identifier={'/teracomdevices'}
          />
          {isAdmin ? (
            <DrawerItem
              linkTo={'/users'}
              icon={<GroupIcon className="blueIcon" />}
              text={localized('Users')}
              selected={item === '/users' ? true : false}
              onMenuItemClicked={setUsers}
              identifier={'/users'}
            />
          ) : (
            <></>
          )}
        </List>

        <div className="userField">
          <Divider />
          <Avatar className="avatar" src={user.picture} />
          <div className="avatarName">{user.name}</div>
          <div className="avatarName">
            {isAuthenticated && <Button onClick={logOut}>{localized('LogOut')}</Button>}{' '}
          </div>
        </div>
      </Drawer>
    </div>
  );
};
export default MenuDrawer;
